import React from 'react';

export function Skeleton({ className = '', rounded = 'rounded', ...props }) {
  return (
    <div
      className={`animate-pulse bg-gray-200 dark:bg-gray-700 ${rounded} ${className}`}
      {...props}
    />
  );
}

export function SkeletonText({ lines = 3, className = '' }) {
  return (
    <div className={`space-y-2 ${className}`}>
      {Array.from({ length: lines }).map((_, i) => (
        <Skeleton
          key={i}
          className={`h-3 ${i === lines - 1 ? 'w-2/3' : 'w-full'}`}
          rounded="rounded"
        />
      ))}
    </div>
  );
}

export function SkeletonCircle({ size = 'w-9 h-9', className = '' }) {
  return <Skeleton className={`${size} ${className}`} rounded="rounded-full" />;
}
